import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, MessageSquarePlus, Share2, HeartHandshake, Heart } from 'lucide-react';

interface MobileEngagementBarProps {
  onSubscribe?: () => void;
  onFeedback?: () => void;
  onShare?: () => void;
  isSubscribed?: boolean;
  monthlyPrice?: string;
  showOnPages?: string[]; // Array of page paths where this should show
}

export const MobileEngagementBar: React.FC<MobileEngagementBarProps> = ({
  onSubscribe,
  onFeedback,
  onShare,
  isSubscribed = false,
  monthlyPrice = '$4.99',
}) => {

  const handleSubscribe = () => {
    if (onSubscribe) {
      onSubscribe();
    }
    // Haptic feedback
    if ('vibrate' in navigator) {
      navigator.vibrate(10);
    }
  };

  const handleFeedback = () => {
    if (onFeedback) {
      onFeedback();
    }
    if ('vibrate' in navigator) {
      navigator.vibrate(10);
    }
  };

  const handleShare = () => {
    if ('vibrate' in navigator) {
      navigator.vibrate(10);
    }
    if (onShare) {
      onShare();
    }
  };

  return (
    <>
      {/* Main Action Bar - pointer-events-none on container, auto on buttons */}
      <motion.div
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        className="fixed bottom-20 left-0 right-0 z-30 pointer-events-none"
        style={{
          paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        }}
      >
        <div className="flex items-stretch pointer-events-auto bg-white border-t border-gray-200">
          {/* Subscribe/Support Button - Primary Action */}
          <button
            onClick={handleSubscribe}
            className={`flex-1 flex flex-col items-center justify-center py-2.5 transition-colors relative ${
              isSubscribed
                ? 'bg-gradient-to-r from-purple-600 to-purple-700 text-white'
                : 'bg-purple-50 text-purple-700 hover:bg-purple-100'
            }`}
          >
            {isSubscribed ? (
              <HeartHandshake size={20} />
            ) : (
              <Heart size={20} />
            )}
            <span className="text-xs font-bold mt-1">
              {isSubscribed ? 'Suscrito' : 'Apoyar'}
            </span>
            {/* Chilean flag badge in top right corner */}
            {!isSubscribed && (
              <div className="absolute top-1 right-1 w-5 h-3.5 rounded-sm overflow-hidden shadow-sm border border-gray-300">
                <img
                  src="/assets/chilean-flag/Flag_of_Chile.svg"
                  alt="Chile"
                  className="w-full h-full object-cover"
                />
              </div>
            )}
          </button>

          <div className="w-px bg-gray-200" />

          {/* Feedback Button */}
          <button
            onClick={handleFeedback}
            className="flex-1 flex flex-col items-center justify-center py-2.5 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
          >
            <MessageSquarePlus size={20} />
            <span className="text-xs font-medium mt-1">Feedback</span>
            <span className="text-[10px] text-gray-500">Sugerencias</span>
          </button>

          <div className="w-px bg-gray-200" />

          {/* Share Button */}
          <button
            onClick={handleShare}
            className="flex-1 flex flex-col items-center justify-center py-2.5 text-gray-700 hover:bg-gray-50 transition-colors"
          >
            <Share2 size={20} />
            <span className="text-xs font-medium mt-1">Compartir</span>
          </button>
        </div>
      </motion.div>
    </>
  );
};